export const visit = (vm, at) => {
at({ "en": { "crmIndexAssociationsLib": { "associationLabel": "{{fromObjectName}}{{inverseLabel}} \u2192 {{toObjectName}}{{label}}" } } });
};